import "@tento-ui/components/event-details/event-details-time-label";

import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { Button } from "@tento-ui/components/button/button";
import { EventDetailsTimeLabel } from "@tento-ui/components/event-details/event-details-time-label";
import { GESTURE_MANAGER } from "@tento-ui/gesture-manager";
import { DateTime } from "@tento-chrono";

@component({
  name: "lona-pending-event-subtitle",
})
export class PendingEventSubtitle extends LonaWebComponent {
  private $timeLabel: EventDetailsTimeLabel = this.hydrate("time-label");
  private $buttonsRow: HTMLElement = this.$("buttons-row");
  private onGoing: Option<() => void>;
  private onNotGoing: Option<() => void>;
  private $goingBtn: Option<HTMLElement> = null;
  private $notGoingBtn: Option<HTMLElement> = null;

  static makeWith(props: PendingEventSubtitle.Props): PendingEventSubtitle {
    const $c = PendingEventSubtitle.make();
    $c.bind(props);
    return $c;
  }

  bind(props: PendingEventSubtitle.Props): this {
    if (this.$goingBtn) GESTURE_MANAGER.unregister(this.$goingBtn);
    if (this.$notGoingBtn) GESTURE_MANAGER.unregister(this.$notGoingBtn);
    this.$buttonsRow.replaceChildren();

    this.onGoing = props.onGoing;
    this.onNotGoing = props.onNotGoing;

    this.$timeLabel.bind(props.time, false, props.use24Hour ?? false);

    const isGoingHighlighted = props.status === "accepted";
    const isNotGoingHighlighted = props.status === "declined";

    this.$notGoingBtn = Button.makeWith("Not going", {
      type: isNotGoingHighlighted ? "primary" : "secondary",
    });
    this.$notGoingBtn.assignStyles({ flex: "1" });
    GESTURE_MANAGER.addPointerEvent(this.$notGoingBtn, {
      onClick: () => this.onNotGoing?.(),
    });

    this.$goingBtn = Button.makeWith("Going", {
      type: isGoingHighlighted ? "primary" : "secondary",
    });
    this.$goingBtn.assignStyles({
      "--bg-btn-hvr": "var(--green-dimmed)",
      flex: "1",
    });
    if (isGoingHighlighted) {
      this.$goingBtn.assignStyles({
        "--bg-btn": "var(--green)",
        "--bg-btn-hvr": "var(--green)",
      });
    }
    GESTURE_MANAGER.addPointerEvent(this.$goingBtn, {
      onClick: () => this.onGoing?.(),
    });

    this.$buttonsRow.appendChild(this.$notGoingBtn);
    this.$buttonsRow.appendChild(this.$goingBtn);

    return this;
  }

  onRecycle() {
    if (this.$goingBtn) GESTURE_MANAGER.unregister(this.$goingBtn);
    if (this.$notGoingBtn) GESTURE_MANAGER.unregister(this.$notGoingBtn);
    this.$goingBtn = null;
    this.$notGoingBtn = null;
    this.onGoing = null;
    this.onNotGoing = null;
  }

  static $styles: Style.Compat[] = [
    css`
      :host {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-top: 0px;
      }

      #buttons-row {
        display: flex;
        flex-direction: row;
        gap: 8px;
      }
    `,
  ];

  static $html: Option<HTMLTemplateElement> = html`
    <std-event-details-time-label id="time-label"></std-event-details-time-label>
    <std-row id="buttons-row"></std-row>
  `;
}

export namespace PendingEventSubtitle {
  export type Status = "accepted" | "declined" | "tentative" | "needsAction";

  export interface Props {
    time: DateTime.Range;
    status?: Option<Status>;
    use24Hour?: boolean;
    onGoing?: () => void;
    onNotGoing?: () => void;
  }
}
